import { type, string } from 'superstruct';
export const CartDrawerIO = type({
    moneyFormat: string()
});
